import {Input} from '@/components/ui/input'
import {cn} from '@/lib/utils'
import {tope} from '@/lib/campos-texto'

/** El tope BUSCA vive acá para que ninguna lista lo olvide: una búsqueda de 10.000 caracteres es un `LIKE` inútil. */
export function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  'data-testid': testId,
}: {
  value: string
  onChange: (valor: string) => void
  placeholder?: string
  className?: string
  'data-testid'?: string
}) {
  return (
    // Sin `type="search"`: la «x» de Chrome y Safari movería las líneas base visuales.
    <Input
      maxLength={tope('BUSCA')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={cn('max-w-xs', className)}
      data-testid={testId}
    />
  )
}
